import { FileText, Download } from "lucide-react";
import { Panel } from "@/components/ui-kit";

const DOCS = [
  ["user-guide", "EP_EDI_Order_Hub_User_Guide.pdf", "EDI Order Hub - Messaging Process & User Guide", "Every flow, screen and procedure for the EDI administrator"],
  ["process-overview", "EP_EDI_Process_Overview.pdf", "Order & Messaging Process Overview", "Process-only version for agreement with Group O, Mondi and the SAP team (no screenshots)"],
  ["sap-pack", "EP_SAP_Team_Pack.pdf", "SAP Team Pack", "Order export template, field map and status file layout for the SAP team"],
  ["as2-partner-info", "EP_AS2_Partner_Information.pdf", "AS2 Partner Information & Go-Live Actions", "EP answers for the TrueCommerce / Group O form, Group O settings and the remaining go-live checklist"],
  ["as2-sheet", "EP_AS2_Connection_Details.pdf", "AS2 Connection Details", "Our AS2 details to send to Group O (use Download AS2 details sheet below for the latest values)"],
  ["amazon-guide", "EP_Amazon_PO_User_Guide.pdf", "Processing Amazon POs - User Guide", "PDF, saved email, manual and spreadsheet methods, pallet pricing, fix missing details and SAP IDoc generation, with diagrams and screenshots"],
  ["havi-guide", "EP_HAVI_Process_User_Guide.pdf", "HAVI / McDonald's - Process & User Guide", "HAVI orders (850 > SAP IDoc > 855 / 856), Assured Supply files, AS2 details and go-live checklist, with flowcharts"],
  ["upload-guide", "EP_PO_Upload_User_Guide.pdf", "PO Upload User - User Guide", "Setting up PO upload users and their customers, uploading, fixing and approving POs, My summary - with flowcharts and screenshots"],
];

export const DocsPanel = () => (
  <Panel title="Documents (PDF)" testId="settings-docs-panel">
    <ul className="divide-y divide-slate-800">
      {DOCS.map(([id, file, title, desc]) => (
        <li key={id} className="flex items-center gap-4 px-5 py-3">
          <FileText className="h-5 w-5 shrink-0 text-rose-400" />
          <div className="min-w-0 flex-1">
            <a href={`/docs/${file}`} target="_blank" rel="noreferrer" className="text-sm text-slate-100 hover:text-rose-300 hover:underline" data-testid={`doc-link-${id}`}>{title}</a>
            <div className="text-xs text-slate-500">{desc}</div>
          </div>
          <a href={`/docs/${file}`} download className="rounded-sm p-2 text-slate-400 transition-colors hover:bg-slate-800 hover:text-slate-100" aria-label={`Download ${title}`} data-testid={`doc-download-${id}`}>
            <Download className="h-4 w-4" />
          </a>
        </li>
      ))}
    </ul>
  </Panel>
);
